import announcementApi from './announcementApi';

const getAnnouncements = async () => {
  try {
    const { data } = await announcementApi.get('/');
    return data;
  } catch (error) {
    console.error('[getAnnouncements] Failed:', error);
    throw error;
  }
};

export default getAnnouncements;
